import './FieldBox.css';

export const FieldBox = ({ children }) => {
  return (
    <div className='field-box mb-4'>
      {children}
    </div>
  );
};